// extracted by mini-css-extract-plugin
module.exports = {"StockOverviewPage":"_ticker__StockOverviewPage__h9i7I"};